<template>
    <popper append-to-body :options="{ placement: position, modifiers: { offset: { offset: positionOffset }} }">
        <div class="popper" :style="{maxWidth: maxWidth + 'px'}">
            <div class="popper__content">
                <a v-if="actionImg" :href="actionUrl" target="_blank">
                    <img :src="actionImg">
                </a>
                <div class="popper__content-wrapper">
                    <h5 class="popper__header-text">
                        {{headerText}}
                    </h5>
                    <span class="popper__description" v-html="descriptionText"></span>
                </div>
            </div>
        </div>
        <template slot="reference">
            <div class="popper__reference" @mouseenter="addHoverClass" @mouseleave="removeHoverClass">
                <a v-if="actionUrl" :href="actionUrl" :class="actionClass">
                    <font-awesome-icon :icon="icon" v-bind:spin="shouldIconSpin" class="animated" :class="[iconClass, iconAnimation]"></font-awesome-icon>
                </a>
                <div v-if="content && contentClasses" class="popper__reference-content" v-bind:style="contentStyles">
                    <span :class="[contentClasses]">
                         <template v-if="iconOnEnd">
                            <span v-html="content"></span>
                            <font-awesome-icon v-if="icon" :icon="icon" v-bind:spin="shouldIconSpin" class="animated ml-1" :class="[iconClass, iconAnimation]"></font-awesome-icon>
                        </template>
                        <template v-else>
                          <font-awesome-icon v-if="icon" :icon="icon" v-bind:spin="shouldIconSpin" class="animated mr-1" :class="[iconClass, iconAnimation]"></font-awesome-icon>
                          <span v-html="content"></span>
                        </template>
                    </span>
                </div>
                <div v-if="onlyIcon" class="popper__reference-content" v-bind:style="contentStyles">
                    <span :class="[contentClasses]">
                        <font-awesome-icon v-if="icon" :icon="icon" v-bind:spin="shouldIconSpin" class="animated mr-1" :class="[iconClass, iconAnimation]"></font-awesome-icon>
                    </span>
                </div>
                <div v-if="onlyText" class="popper__reference-content" v-bind:style="contentStyles">
                    {{content}}
                </div>

            </div>
        </template>
    </popper>
</template>

<script>
  import Popper from 'vue-popperjs';
  import 'vue-popperjs/dist/css/vue-popper.css';
  export default {
    props: {
      position: {
        type: String,
        default: 'top',
      },
      positionOffset: {
        type: String,
        default: '0,8px',
      },
      headerText: {
        type: String,
        required: true
      },
      descriptionText: {
        type: String,
      },
      icon: {
        type: String | Array,
      },
      iconClass: {
        type: String,
      },
      iconOnEnd: {
        type: Boolean,
        default: false,
      },
      iconAnimation: {
        type: String,
        default: 'fadeIn',
      },
      actionUrl: {
        type: String,
      },
      actionImg: {
        type: String,
      },
      actionClass: {
        type: String,
      },
      maxWidth: {
        type: Number,
      },
      content: {
        type: String,
      },
      contentClasses: {
        type: String,
      },
      contentStyles: {
        type: String,
      },
      onlyIcon: {
        type: Boolean,
        default: false,
      },
      onlyText: {
        type: Boolean,
        default: false,
      },
      shouldIconSpin: {
         type: Boolean,
         default: false,
      },
    },
    data() {
      return {

      }
    },
    methods: {
      addHoverClass: function (e) {
        if (!e.target.classList.contains("popper--hovered")) {
          e.target.classList.add("popper--hovered");
        }
      },
      removeHoverClass: function (e) {
        if (e.target.classList.contains("popper--hovered")) {
          e.target.classList.remove("popper--hovered");
        }
      },
    },
    components: {
      'popper': Popper
    },
  }
</script>
